export default "__VITE_ASSET__CXRWAlqF__"